import * as React from "react";
import {oktaSignOut} from "../../utils/oktaUtil";
import {handleEnter} from "../../utils/commonUtil";
import {IRIS_ORIGINAL_URI_KEY, IRIS_WAS_AUTHENTICATED_KEY} from "../root/SecureRoute";

export interface ICorsErrorModalOpen{
    setCorsErrorModalOpen: (is: boolean) => void;
}
export const OktaLogOut: React.FunctionComponent<ICorsErrorModalOpen> = (props) => {

    const isCorsError = (err: any) =>
        (err.name === "AuthApiError" && !err.errorCode && err.xhr.message === "Failed to fetch");

    const logout = async () => {
        const basename = window.location.origin +  "/" ;
        localStorage.removeItem(IRIS_WAS_AUTHENTICATED_KEY);
        localStorage.removeItem(IRIS_ORIGINAL_URI_KEY);
        try {
            await oktaSignOut({
                postLogoutRedirectUri: basename,
                revokeAccessToken: true
            });
        } catch (err) {
            if (isCorsError(err)) {
                props.setCorsErrorModalOpen(true);
            } else {
                throw err;
            }
        }
    };

    return <div className="clickable-menu-item">
        {/* eslint-disable @typescript-eslint/no-misused-promises */}
        <a className="menu__item user-menu__item--signout old-anchor" id="logout" data-testid="logout"
           tabIndex={-1}
           onKeyUp={handleEnter(logout)}
           onClick={logout}>
            <i className="fa-light fa-right-from-bracket" aria-hidden="true" />
            <span>Sign Out</span>
        </a>
    </div>;

};